// commons
import { AgbFormLocalization, CalendarLocalization } from '@libs/index';
import contactDataFormCz from '@libs/ui/contact-data-form/i18n/cz.json';
import contactDataFormDe from '@libs/ui/contact-data-form/i18n/de.json';
import contactDataFormFr from '@libs/ui/contact-data-form/i18n/fr.json';
import contactDataFormUs from '@libs/ui/contact-data-form/i18n/us.json';
import contactDataFormVn from '@libs/ui/contact-data-form/i18n/vn.json';
import emailPhoneConfirmationPinDialogCz from '@libs/ui/email-phone-confirmation-pin-dialog/i18n/cz.json';
import emailPhoneConfirmationPinDialogDe from '@libs/ui/email-phone-confirmation-pin-dialog/i18n/de.json';
import emailPhoneConfirmationPinDialogFr from '@libs/ui/email-phone-confirmation-pin-dialog/i18n/fr.json';
import emailPhoneConfirmationPinDialogUs from '@libs/ui/email-phone-confirmation-pin-dialog/i18n/us.json';
import emailPhoneConfirmationPinDialogVn from '@libs/ui/email-phone-confirmation-pin-dialog/i18n/vn.json';
import languageSelectionDialogCz from '@libs/ui/language-selection-dialog/i18n/cz.json';
import languageSelectionDialogDe from '@libs/ui/language-selection-dialog/i18n/de.json';
import languageSelectionDialogFr from '@libs/ui/language-selection-dialog/i18n/fr.json';
import languageSelectionDialogUs from '@libs/ui/language-selection-dialog/i18n/us.json';
import languageSelectionDialogVn from '@libs/ui/language-selection-dialog/i18n/vn.json';
import newAppVersionNotificationCz from '@libs/ui/new-app-version-notification/i18n/cz.json';
import newAppVersionNotificationDe from '@libs/ui/new-app-version-notification/i18n/de.json';
import newAppVersionNotificationFr from '@libs/ui/new-app-version-notification/i18n/fr.json';
import newAppVersionNotificationUs from '@libs/ui/new-app-version-notification/i18n/us.json';
import newAppVersionNotificationVn from '@libs/ui/new-app-version-notification/i18n/vn.json';
import passwordFormCz from '@libs/ui/password-form/i18n/cz.json';
import passwordFormDe from '@libs/ui/password-form/i18n/de.json';
import passwordFormFr from '@libs/ui/password-form/i18n/fr.json';
import passwordFormUs from '@libs/ui/password-form/i18n/us.json';
import passwordFormVn from '@libs/ui/password-form/i18n/vn.json';
import personalDataFormCz from '@libs/ui/personal-data-form/i18n/cz.json';
import personalDataFormDe from '@libs/ui/personal-data-form/i18n/de.json';
import personalDataFormFr from '@libs/ui/personal-data-form/i18n/fr.json';
import personalDataFormUs from '@libs/ui/personal-data-form/i18n/us.json';
import personalDataFormVn from '@libs/ui/personal-data-form/i18n/vn.json';
import updatePasswordPinDialogCz from '@libs/ui/update-password-pin-dialog/i18n/cz.json';
import updatePasswordPinDialogDe from '@libs/ui/update-password-pin-dialog/i18n/de.json';
import updatePasswordPinDialogFr from '@libs/ui/update-password-pin-dialog/i18n/fr.json';
import updatePasswordPinDialogUs from '@libs/ui/update-password-pin-dialog/i18n/us.json';
import updatePasswordPinDialogVn from '@libs/ui/update-password-pin-dialog/i18n/vn.json';
import updateProfileCz from '@libs/ui/user-profile/i18n/cz.json';
import updateProfileDe from '@libs/ui/user-profile/i18n/de.json';
import updateProfileFr from '@libs/ui/user-profile/i18n/fr.json';
import updateProfileUs from '@libs/ui/user-profile/i18n/us.json';
import updateProfileVn from '@libs/ui/user-profile/i18n/vn.json';

// pages - auth-process
import authProcessPagesCz from '../../pages/auth-process-pages/i18n/cz.json';
import authProcessPagesDe from '../../pages/auth-process-pages/i18n/de.json';
import authProcessPagesFr from '../../pages/auth-process-pages/i18n/fr.json';
import authProcessPagesUs from '../../pages/auth-process-pages/i18n/us.json';
import authProcessPagesVn from '../../pages/auth-process-pages/i18n/vn.json';
import accountExistedDialogCz from '../../pages/auth-process-pages/components/account-existed-dialog/i18n/cz.json';
import accountExistedDialogDe from '../../pages/auth-process-pages/components/account-existed-dialog/i18n/de.json';
import accountExistedDialogFr from '../../pages/auth-process-pages/components/account-existed-dialog/i18n/fr.json';
import accountExistedDialogUs from '../../pages/auth-process-pages/components/account-existed-dialog/i18n/us.json';
import accountExistedDialogVn from '../../pages/auth-process-pages/components/account-existed-dialog/i18n/vn.json';
import accountNotExistedDialogCz from '../../pages/auth-process-pages/components/account-not-existed-dialog/i18n/cz.json';
import accountNotExistedDialogDe from '../../pages/auth-process-pages/components/account-not-existed-dialog/i18n/de.json';
import accountNotExistedDialogFr from '../../pages/auth-process-pages/components/account-not-existed-dialog/i18n/fr.json';
import accountNotExistedDialogUs from '../../pages/auth-process-pages/components/account-not-existed-dialog/i18n/us.json';
import accountNotExistedDialogVn from '../../pages/auth-process-pages/components/account-not-existed-dialog/i18n/vn.json';
import loginPageCz from '../../pages/auth-process-pages/login-page/i18n/cz.json';
import loginPageDe from '../../pages/auth-process-pages/login-page/i18n/de.json';
import loginPageFr from '../../pages/auth-process-pages/login-page/i18n/fr.json';
import loginPageUs from '../../pages/auth-process-pages/login-page/i18n/us.json';
import loginPageVn from '../../pages/auth-process-pages/login-page/i18n/vn.json';
import loginSecretWithPasswordPageCz from '../../pages/auth-process-pages/login-secret-with-password-page/i18n/cz.json';
import loginSecretWithPasswordPageDe from '../../pages/auth-process-pages/login-secret-with-password-page/i18n/de.json';
import loginSecretWithPasswordPageFr from '../../pages/auth-process-pages/login-secret-with-password-page/i18n/fr.json';
import loginSecretWithPasswordPageUs from '../../pages/auth-process-pages/login-secret-with-password-page/i18n/us.json';
import loginSecretWithPasswordPageVn from '../../pages/auth-process-pages/login-secret-with-password-page/i18n/vn.json';
import loginSecretWithPinPageCz from '../../pages/auth-process-pages/login-secret-with-pin-page/i18n/cz.json';
import loginSecretWithPinPageDe from '../../pages/auth-process-pages/login-secret-with-pin-page/i18n/de.json';
import loginSecretWithPinPageFr from '../../pages/auth-process-pages/login-secret-with-pin-page/i18n/fr.json';
import loginSecretWithPinPageUs from '../../pages/auth-process-pages/login-secret-with-pin-page/i18n/us.json';
import loginSecretWithPinPageVn from '../../pages/auth-process-pages/login-secret-with-pin-page/i18n/vn.json';
import registerPersonalDataPageCz from '../../pages/auth-process-pages/register-personal-data-page/i18n/cz.json';
import registerPersonalDataPageDe from '../../pages/auth-process-pages/register-personal-data-page/i18n/de.json';
import registerPersonalDataPageFr from '../../pages/auth-process-pages/register-personal-data-page/i18n/fr.json';
import registerPersonalDataPageUs from '../../pages/auth-process-pages/register-personal-data-page/i18n/us.json';
import registerPersonalDataPageVn from '../../pages/auth-process-pages/register-personal-data-page/i18n/vn.json';
import registerPinPageCz from '../../pages/auth-process-pages/register-pin-page/i18n/cz.json';
import registerPinPageDe from '../../pages/auth-process-pages/register-pin-page/i18n/de.json';
import registerPinPageFr from '../../pages/auth-process-pages/register-pin-page/i18n/fr.json';
import registerPinPageUs from '../../pages/auth-process-pages/register-pin-page/i18n/us.json';
import registerPinPageVn from '../../pages/auth-process-pages/register-pin-page/i18n/vn.json';
import registerSecretDataPageCz from '../../pages/auth-process-pages/register-secret-data-page/i18n/cz.json';
import registerSecretDataPageDe from '../../pages/auth-process-pages/register-secret-data-page/i18n/de.json';
import registerSecretDataPageFr from '../../pages/auth-process-pages/register-secret-data-page/i18n/fr.json';
import registerSecretDataPageUs from '../../pages/auth-process-pages/register-secret-data-page/i18n/us.json';
import registerSecretDataPageVn from '../../pages/auth-process-pages/register-secret-data-page/i18n/vn.json';
import registerSuccessDataPageCz from '../../pages/auth-process-pages/register-success-page/i18n/cz.json';
import registerSuccessDataPageDe from '../../pages/auth-process-pages/register-success-page/i18n/de.json';
import registerSuccessDataPageFr from '../../pages/auth-process-pages/register-success-page/i18n/fr.json';
import registerSuccessDataPageUs from '../../pages/auth-process-pages/register-success-page/i18n/us.json';
import registerSuccessDataPageVn from '../../pages/auth-process-pages/register-success-page/i18n/vn.json';

// pages - components
import agbToAcceptCz from '../../pages/components/agb-to-accept-dialog/i18n/cz.json';
import agbToAcceptDe from '../../pages/components/agb-to-accept-dialog/i18n/de.json';
import agbToAcceptFr from '../../pages/components/agb-to-accept-dialog/i18n/fr.json';
import agbToAcceptUs from '../../pages/components/agb-to-accept-dialog/i18n/us.json';
import agbToAcceptVn from '../../pages/components/agb-to-accept-dialog/i18n/vn.json';
import appFrameCz from '../../pages/components/app-frame/i18n/cz.json';
import appFrameDe from '../../pages/components/app-frame/i18n/de.json';
import appFrameFr from '../../pages/components/app-frame/i18n/fr.json';
import appFrameUs from '../../pages/components/app-frame/i18n/us.json';
import appFrameVn from '../../pages/components/app-frame/i18n/vn.json';
import buttonBarForContinueBookingCz from '../../pages/components/button-bar-for-continue-booking/i18n/cz.json';
import buttonBarForContinueBookingDe from '../../pages/components/button-bar-for-continue-booking/i18n/de.json';
import buttonBarForContinueBookingFr from '../../pages/components/button-bar-for-continue-booking/i18n/fr.json';
import buttonBarForContinueBookingUs from '../../pages/components/button-bar-for-continue-booking/i18n/us.json';
import buttonBarForContinueBookingVn from '../../pages/components/button-bar-for-continue-booking/i18n/vn.json';
import buttonBarForSelectedServiceCz from '../../pages/components/button-bar-for-selected-service/i18n/cz.json';
import buttonBarForSelectedServiceDe from '../../pages/components/button-bar-for-selected-service/i18n/de.json';
import buttonBarForSelectedServiceFr from '../../pages/components/button-bar-for-selected-service/i18n/fr.json';
import buttonBarForSelectedServiceUs from '../../pages/components/button-bar-for-selected-service/i18n/us.json';
import buttonBarForSelectedServiceVn from '../../pages/components/button-bar-for-selected-service/i18n/vn.json';
import contactUpdateDialogCz from '../../pages/components/contact-update-dialog/i18n/cz.json';
import contactUpdateDialogDe from '../../pages/components/contact-update-dialog/i18n/de.json';
import contactUpdateDialogFr from '../../pages/components/contact-update-dialog/i18n/fr.json';
import contactUpdateDialogUs from '../../pages/components/contact-update-dialog/i18n/us.json';
import contactUpdateDialogVn from '../../pages/components/contact-update-dialog/i18n/vn.json';
import cookiesDialogCz from '../../pages/components/cookies-dialog/i18n/cz.json';
import cookiesDialogDe from '../../pages/components/cookies-dialog/i18n/de.json';
import cookiesDialogFr from '../../pages/components/cookies-dialog/i18n/fr.json';
import cookiesDialogUs from '../../pages/components/cookies-dialog/i18n/us.json';
import cookiesDialogVn from '../../pages/components/cookies-dialog/i18n/vn.json';
import footerCz from '../../pages/components/footer/i18n/cz.json';
import footerDe from '../../pages/components/footer/i18n/de.json';
import footerFr from '../../pages/components/footer/i18n/fr.json';
import footerUs from '../../pages/components/footer/i18n/us.json';
import footerVn from '../../pages/components/footer/i18n/vn.json';
import googleMapsEmbedIframeDialogCz from '../../pages/components/google-maps-embed-iframe-dialog/i18n/cz.json';
import googleMapsEmbedIframeDialogDe from '../../pages/components/google-maps-embed-iframe-dialog/i18n/de.json';
import googleMapsEmbedIframeDialogFr from '../../pages/components/google-maps-embed-iframe-dialog/i18n/fr.json';
import googleMapsEmbedIframeDialogUs from '../../pages/components/google-maps-embed-iframe-dialog/i18n/us.json';
import googleMapsEmbedIframeDialogVn from '../../pages/components/google-maps-embed-iframe-dialog/i18n/vn.json';
import navigationBackButtonCz from '../../pages/components/navigation-back-button/i18n/cz.json';
import navigationBackButtonDe from '../../pages/components/navigation-back-button/i18n/de.json';
import navigationBackButtonFr from '../../pages/components/navigation-back-button/i18n/fr.json';
import navigationBackButtonUs from '../../pages/components/navigation-back-button/i18n/us.json';
import navigationBackButtonVn from '../../pages/components/navigation-back-button/i18n/vn.json';
import processContainerCz from '../../pages/components/process-container/i18n/cz.json';
import processContainerDe from '../../pages/components/process-container/i18n/de.json';
import processContainerFr from '../../pages/components/process-container/i18n/fr.json';
import processContainerUs from '../../pages/components/process-container/i18n/us.json';
import processContainerVn from '../../pages/components/process-container/i18n/vn.json';
import ratingStarIconCz from '../../pages/components/rating-star-icon/i18n/cz.json';
import ratingStarIconDe from '../../pages/components/rating-star-icon/i18n/de.json';
import ratingStarIconFr from '../../pages/components/rating-star-icon/i18n/fr.json';
import ratingStarIconUs from '../../pages/components/rating-star-icon/i18n/us.json';
import ratingStarIconVn from '../../pages/components/rating-star-icon/i18n/vn.json';
import salonCardCz from '../../pages/components/salon-card/i18n/cz.json';
import salonCardDe from '../../pages/components/salon-card/i18n/de.json';
import salonCardFr from '../../pages/components/salon-card/i18n/fr.json';
import salonCardUs from '../../pages/components/salon-card/i18n/us.json';
import salonCardVn from '../../pages/components/salon-card/i18n/vn.json';
import cityCardCz from '../../pages/components/city-card/i18n/cz.json';
import cityCardDe from '../../pages/components/city-card/i18n/de.json';
import cityCardFr from '../../pages/components/city-card/i18n/fr.json';
import cityCardUs from '../../pages/components/city-card/i18n/us.json';
import cityCardVn from '../../pages/components/city-card/i18n/vn.json';
import salonDetailsHeaderCz from '../../pages/components/salon-details-header/i18n/cz.json';
import salonDetailsHeaderDe from '../../pages/components/salon-details-header/i18n/de.json';
import salonDetailsHeaderFr from '../../pages/components/salon-details-header/i18n/fr.json';
import salonDetailsHeaderUs from '../../pages/components/salon-details-header/i18n/us.json';
import salonDetailsHeaderVn from '../../pages/components/salon-details-header/i18n/vn.json';
import staticContentBecomePartnerCz from '../../pages/components/static-content-become-partner/i18n/cz.json';
import staticContentBecomePartnerDe from '../../pages/components/static-content-become-partner/i18n/de.json';
import staticContentBecomePartnerFr from '../../pages/components/static-content-become-partner/i18n/fr.json';
import staticContentBecomePartnerUs from '../../pages/components/static-content-become-partner/i18n/us.json';
import staticContentBecomePartnerVn from '../../pages/components/static-content-become-partner/i18n/vn.json';
import staticContentDownloadAppCz from '../../pages/components/static-content-download-app/i18n/cz.json';
import staticContentDownloadAppDe from '../../pages/components/static-content-download-app/i18n/de.json';
import staticContentDownloadAppFr from '../../pages/components/static-content-download-app/i18n/fr.json';
import staticContentDownloadAppUs from '../../pages/components/static-content-download-app/i18n/us.json';
import staticContentDownloadAppVn from '../../pages/components/static-content-download-app/i18n/vn.json';
import staticContentOnlineBookingBenefitCz from '../../pages/components/static-content-online-booking-benefit/i18n/cz.json';
import staticContentOnlineBookingBenefitDe from '../../pages/components/static-content-online-booking-benefit/i18n/de.json';
import staticContentOnlineBookingBenefitFr from '../../pages/components/static-content-online-booking-benefit/i18n/fr.json';
import staticContentOnlineBookingBenefitUs from '../../pages/components/static-content-online-booking-benefit/i18n/us.json';
import staticContentOnlineBookingBenefitVn from '../../pages/components/static-content-online-booking-benefit/i18n/vn.json';
import staticContentOnlineBookingProcessCz from '../../pages/components/static-content-online-booking-process/i18n/cz.json';
import staticContentOnlineBookingProcessDe from '../../pages/components/static-content-online-booking-process/i18n/de.json';
import staticContentOnlineBookingProcessFr from '../../pages/components/static-content-online-booking-process/i18n/fr.json';
import staticContentOnlineBookingProcessUs from '../../pages/components/static-content-online-booking-process/i18n/us.json';
import staticContentOnlineBookingProcessVn from '../../pages/components/static-content-online-booking-process/i18n/vn.json';

// pages - feedback-process
import feedbackProcessPagesCz from '../../pages/feedback-process-pages/i18n/cz.json';
import feedbackProcessPagesDe from '../../pages/feedback-process-pages/i18n/de.json';
import feedbackProcessPagesFr from '../../pages/feedback-process-pages/i18n/fr.json';
import feedbackProcessPagesUs from '../../pages/feedback-process-pages/i18n/us.json';
import feedbackProcessPagesVn from '../../pages/feedback-process-pages/i18n/vn.json';
import feedbackEmotionPageCz from '../../pages/feedback-process-pages/feedback-emotion-page/i18n/cz.json';
import feedbackEmotionPageDe from '../../pages/feedback-process-pages/feedback-emotion-page/i18n/de.json';
import feedbackEmotionPageFr from '../../pages/feedback-process-pages/feedback-emotion-page/i18n/fr.json';
import feedbackEmotionPageUs from '../../pages/feedback-process-pages/feedback-emotion-page/i18n/us.json';
import feedbackEmotionPageVn from '../../pages/feedback-process-pages/feedback-emotion-page/i18n/vn.json';
import feedbackInternalDetailsPageCz from '../../pages/feedback-process-pages/feedback-internal-details-page/i18n/cz.json';
import feedbackInternalDetailsPageDe from '../../pages/feedback-process-pages/feedback-internal-details-page/i18n/de.json';
import feedbackInternalDetailsPageFr from '../../pages/feedback-process-pages/feedback-internal-details-page/i18n/fr.json';
import feedbackInternalDetailsPageUs from '../../pages/feedback-process-pages/feedback-internal-details-page/i18n/us.json';
import feedbackInternalDetailsPageVn from '../../pages/feedback-process-pages/feedback-internal-details-page/i18n/vn.json';
import feedbackInternalSuccessPageCz from '../../pages/feedback-process-pages/feedback-internal-success-page/i18n/cz.json';
import feedbackInternalSuccessPageDe from '../../pages/feedback-process-pages/feedback-internal-success-page/i18n/de.json';
import feedbackInternalSuccessPageFr from '../../pages/feedback-process-pages/feedback-internal-success-page/i18n/fr.json';
import feedbackInternalSuccessPageUs from '../../pages/feedback-process-pages/feedback-internal-success-page/i18n/us.json';
import feedbackInternalSuccessPageVn from '../../pages/feedback-process-pages/feedback-internal-success-page/i18n/vn.json';

// pages - private
import appointmentDetailsPageCz from '../../pages/private-pages/appointment-details-page/i18n/cz.json';
import appointmentDetailsPageDe from '../../pages/private-pages/appointment-details-page/i18n/de.json';
import appointmentDetailsPageFr from '../../pages/private-pages/appointment-details-page/i18n/fr.json';
import appointmentDetailsPageUs from '../../pages/private-pages/appointment-details-page/i18n/us.json';
import appointmentDetailsPageVn from '../../pages/private-pages/appointment-details-page/i18n/vn.json';
import appointmentHistoryPageCz from '../../pages/private-pages/appointment-history-page/i18n/cz.json';
import appointmentHistoryPageDe from '../../pages/private-pages/appointment-history-page/i18n/de.json';
import appointmentHistoryPageFr from '../../pages/private-pages/appointment-history-page/i18n/fr.json';
import appointmentHistoryPageUs from '../../pages/private-pages/appointment-history-page/i18n/us.json';
import appointmentHistoryPageVn from '../../pages/private-pages/appointment-history-page/i18n/vn.json';
import accountPageContainerCz from '../../pages/private-pages/components/account-page-container/i18n/cz.json';
import accountPageContainerDe from '../../pages/private-pages/components/account-page-container/i18n/de.json';
import accountPageContainerFr from '../../pages/private-pages/components/account-page-container/i18n/fr.json';
import accountPageContainerUs from '../../pages/private-pages/components/account-page-container/i18n/us.json';
import accountPageContainerVn from '../../pages/private-pages/components/account-page-container/i18n/vn.json';
import appointmentCardCz from '../../pages/private-pages/components/appointment-card/i18n/cz.json';
import appointmentCardDe from '../../pages/private-pages/components/appointment-card/i18n/de.json';
import appointmentCardFr from '../../pages/private-pages/components/appointment-card/i18n/fr.json';
import appointmentCardUs from '../../pages/private-pages/components/appointment-card/i18n/us.json';
import appointmentCardVn from '../../pages/private-pages/components/appointment-card/i18n/vn.json';
import qrCheckinConfigPageCz from '../../pages/private-pages/qr-checkin-config-page/i18n/cz.json';
import qrCheckinConfigPageDe from '../../pages/private-pages/qr-checkin-config-page/i18n/de.json';
import qrCheckinConfigPageFr from '../../pages/private-pages/qr-checkin-config-page/i18n/fr.json';
import qrCheckinConfigPageUs from '../../pages/private-pages/qr-checkin-config-page/i18n/us.json';
import qrCheckinConfigPageVn from '../../pages/private-pages/qr-checkin-config-page/i18n/vn.json';
import qrCheckinSuccessPageCz from '../../pages/private-pages/qr-checkin-success-page/i18n/cz.json';
import qrCheckinSuccessPageDe from '../../pages/private-pages/qr-checkin-success-page/i18n/de.json';
import qrCheckinSuccessPageFr from '../../pages/private-pages/qr-checkin-success-page/i18n/fr.json';
import qrCheckinSuccessPageUs from '../../pages/private-pages/qr-checkin-success-page/i18n/us.json';
import qrCheckinSuccessPageVn from '../../pages/private-pages/qr-checkin-success-page/i18n/vn.json';
import salonVisitedPageCz from '../../pages/private-pages/salon-visited-page/i18n/cz.json';
import salonVisitedPageDe from '../../pages/private-pages/salon-visited-page/i18n/de.json';
import salonVisitedPageFr from '../../pages/private-pages/salon-visited-page/i18n/fr.json';
import salonVisitedPageUs from '../../pages/private-pages/salon-visited-page/i18n/us.json';
import salonVisitedPageVn from '../../pages/private-pages/salon-visited-page/i18n/vn.json';
import userProfilePageCz from '../../pages/private-pages/user-profile-page/i18n/cz.json';
import userProfilePageDe from '../../pages/private-pages/user-profile-page/i18n/de.json';
import userProfilePageFr from '../../pages/private-pages/user-profile-page/i18n/fr.json';
import userProfilePageUs from '../../pages/private-pages/user-profile-page/i18n/us.json';
import userProfilePageVn from '../../pages/private-pages/user-profile-page/i18n/vn.json';

// pages - public
import customerRegisterDialogCz from '../../pages/public-pages/components/customer-register-dialog/i18n/cz.json';
import customerRegisterDialogDe from '../../pages/public-pages/components/customer-register-dialog/i18n/de.json';
import customerRegisterDialogFr from '../../pages/public-pages/components/customer-register-dialog/i18n/fr.json';
import customerRegisterDialogUs from '../../pages/public-pages/components/customer-register-dialog/i18n/us.json';
import customerRegisterDialogVn from '../../pages/public-pages/components/customer-register-dialog/i18n/vn.json';
import customerRegisterFormCz from '../../pages/public-pages/components/customer-register-form/i18n/cz.json';
import customerRegisterFormDe from '../../pages/public-pages/components/customer-register-form/i18n/de.json';
import customerRegisterFormFr from '../../pages/public-pages/components/customer-register-form/i18n/fr.json';
import customerRegisterFormUs from '../../pages/public-pages/components/customer-register-form/i18n/us.json';
import customerRegisterFormVn from '../../pages/public-pages/components/customer-register-form/i18n/vn.json';
import customerRequestOnlineBookingDialogCz from '../../pages/public-pages/components/customer-request-online-booking-dialog/i18n/cz.json';
import customerRequestOnlineBookingDialogDe from '../../pages/public-pages/components/customer-request-online-booking-dialog/i18n/de.json';
import customerRequestOnlineBookingDialogFr from '../../pages/public-pages/components/customer-request-online-booking-dialog/i18n/fr.json';
import customerRequestOnlineBookingDialogUs from '../../pages/public-pages/components/customer-request-online-booking-dialog/i18n/us.json';
import customerRequestOnlineBookingDialogVn from '../../pages/public-pages/components/customer-request-online-booking-dialog/i18n/vn.json';
import salonBookingConfigPageCz from '../../pages/public-pages/salon-booking-config-page/i18n/cz.json';
import salonBookingConfigPageDe from '../../pages/public-pages/salon-booking-config-page/i18n/de.json';
import salonBookingConfigPageFr from '../../pages/public-pages/salon-booking-config-page/i18n/fr.json';
import salonBookingConfigPageUs from '../../pages/public-pages/salon-booking-config-page/i18n/us.json';
import salonBookingConfigPageVn from '../../pages/public-pages/salon-booking-config-page/i18n/vn.json';
import salonDetailsFooterCz from '../../pages/public-pages/components/salon-details-footer/i18n/cz.json';
import salonDetailsFooterDe from '../../pages/public-pages/components/salon-details-footer/i18n/de.json';
import salonDetailsFooterFr from '../../pages/public-pages/components/salon-details-footer/i18n/fr.json';
import salonDetailsFooterUs from '../../pages/public-pages/components/salon-details-footer/i18n/us.json';
import salonDetailsFooterVn from '../../pages/public-pages/components/salon-details-footer/i18n/vn.json';
import salonSearchContainerCz from '../../pages/public-pages/components/salon-search-container/i18n/cz.json';
import salonSearchContainerDe from '../../pages/public-pages/components/salon-search-container/i18n/de.json';
import salonSearchContainerFr from '../../pages/public-pages/components/salon-search-container/i18n/fr.json';
import salonSearchContainerUs from '../../pages/public-pages/components/salon-search-container/i18n/us.json';
import salonSearchContainerVn from '../../pages/public-pages/components/salon-search-container/i18n/vn.json';
import salonSearchFormCz from '../../pages/public-pages/components/salon-search-form/i18n/cz.json';
import salonSearchFormDe from '../../pages/public-pages/components/salon-search-form/i18n/de.json';
import salonSearchFormFr from '../../pages/public-pages/components/salon-search-form/i18n/fr.json';
import salonSearchFormUs from '../../pages/public-pages/components/salon-search-form/i18n/us.json';
import salonSearchFormVn from '../../pages/public-pages/components/salon-search-form/i18n/vn.json';
import salonSearchFormAdvanceDialogCz from '../../pages/public-pages/components/salon-search-form-advance-dialog/i18n/cz.json';
import salonSearchFormAdvanceDialogDe from '../../pages/public-pages/components/salon-search-form-advance-dialog/i18n/de.json';
import salonSearchFormAdvanceDialogFr from '../../pages/public-pages/components/salon-search-form-advance-dialog/i18n/fr.json';
import salonSearchFormAdvanceDialogUs from '../../pages/public-pages/components/salon-search-form-advance-dialog/i18n/us.json';
import salonSearchFormAdvanceDialogVn from '../../pages/public-pages/components/salon-search-form-advance-dialog/i18n/vn.json';
import googleSalonDetailsPageCz from '../../pages/public-pages/google-salon-details-page/i18n/cz.json';
import googleSalonDetailsPageDe from '../../pages/public-pages/google-salon-details-page/i18n/de.json';
import googleSalonDetailsPageFr from '../../pages/public-pages/google-salon-details-page/i18n/fr.json';
import googleSalonDetailsPageUs from '../../pages/public-pages/google-salon-details-page/i18n/us.json';
import googleSalonDetailsPageVn from '../../pages/public-pages/google-salon-details-page/i18n/vn.json';
import homePageCz from '../../pages/public-pages/home-page/i18n/cz.json';
import homePageDe from '../../pages/public-pages/home-page/i18n/de.json';
import homePageFr from '../../pages/public-pages/home-page/i18n/fr.json';
import homePageUs from '../../pages/public-pages/home-page/i18n/us.json';
import homePageVn from '../../pages/public-pages/home-page/i18n/vn.json';
import imprintPageCz from '../../pages/public-pages/imprint-page/i18n/cz.json';
import imprintPageDe from '../../pages/public-pages/imprint-page/i18n/de.json';
import imprintPageFr from '../../pages/public-pages/imprint-page/i18n/fr.json';
import imprintPageUs from '../../pages/public-pages/imprint-page/i18n/us.json';
import imprintPageVn from '../../pages/public-pages/imprint-page/i18n/vn.json';
import privacyPolicyPageCz from '../../pages/public-pages/privacy-policy-page/i18n/cz.json';
import privacyPolicyPageDe from '../../pages/public-pages/privacy-policy-page/i18n/de.json';
import privacyPolicyPageFr from '../../pages/public-pages/privacy-policy-page/i18n/fr.json';
import privacyPolicyPageUs from '../../pages/public-pages/privacy-policy-page/i18n/us.json';
import privacyPolicyPageVn from '../../pages/public-pages/privacy-policy-page/i18n/vn.json';
import publicAppointmentDetailsPageCz from '../../pages/public-pages/public-appointment-details-page/i18n/cz.json';
import publicAppointmentDetailsPageDe from '../../pages/public-pages/public-appointment-details-page/i18n/de.json';
import publicAppointmentDetailsPageFr from '../../pages/public-pages/public-appointment-details-page/i18n/fr.json';
import publicAppointmentDetailsPageUs from '../../pages/public-pages/public-appointment-details-page/i18n/us.json';
import publicAppointmentDetailsPageVn from '../../pages/public-pages/public-appointment-details-page/i18n/vn.json';
import rwgCancelRequestPageCz from '../../pages/public-pages/rwg-cancel-request-page/i18n/cz.json';
import rwgCancelRequestPageDe from '../../pages/public-pages/rwg-cancel-request-page/i18n/de.json';
import rwgCancelRequestPageFr from '../../pages/public-pages/rwg-cancel-request-page/i18n/fr.json';
import rwgCancelRequestPageUs from '../../pages/public-pages/rwg-cancel-request-page/i18n/us.json';
import rwgCancelRequestPageVn from '../../pages/public-pages/rwg-cancel-request-page/i18n/vn.json';
import salonDetailsPageCz from '../../pages/public-pages/salon-details-page/i18n/cz.json';
import salonDetailsPageDe from '../../pages/public-pages/salon-details-page/i18n/de.json';
import salonDetailsPageFr from '../../pages/public-pages/salon-details-page/i18n/fr.json';
import salonDetailsPageUs from '../../pages/public-pages/salon-details-page/i18n/us.json';
import salonDetailsPageVn from '../../pages/public-pages/salon-details-page/i18n/vn.json';
import salonSearchResultPageCz from '../../pages/public-pages/salon-search-result-page/i18n/cz.json';
import salonSearchResultPageDe from '../../pages/public-pages/salon-search-result-page/i18n/de.json';
import salonSearchResultPageFr from '../../pages/public-pages/salon-search-result-page/i18n/fr.json';
import salonSearchResultPageUs from '../../pages/public-pages/salon-search-result-page/i18n/us.json';
import salonSearchResultPageVn from '../../pages/public-pages/salon-search-result-page/i18n/vn.json';
import topSalonsPageCz from '../../pages/public-pages/top-salons-page/i18n/cz.json';
import topSalonsPageDe from '../../pages/public-pages/top-salons-page/i18n/de.json';
import topSalonsPageFr from '../../pages/public-pages/top-salons-page/i18n/fr.json';
import topSalonsPageUs from '../../pages/public-pages/top-salons-page/i18n/us.json';
import topSalonsPageVn from '../../pages/public-pages/top-salons-page/i18n/vn.json';
import topSalonsCityPageCz from '../../pages/public-pages/top-salons-city-page/i18n/cz.json';
import topSalonsCityPageDe from '../../pages/public-pages/top-salons-city-page/i18n/de.json';
import topSalonsCityPageFr from '../../pages/public-pages/top-salons-city-page/i18n/fr.json';
import topSalonsCityPageUs from '../../pages/public-pages/top-salons-city-page/i18n/us.json';
import topSalonsCityPageVn from '../../pages/public-pages/top-salons-city-page/i18n/vn.json';

class LanguageLoaderHelper {
  getCzLanguageSet() {
    return {
      // common
      ...AgbFormLocalization.getCzLanguageSet(),
      ...CalendarLocalization.getCzLanguageSet(),
      ...updateProfileCz,

      // pages - auth-process
      ...authProcessPagesCz,
      ...accountExistedDialogCz,
      ...accountNotExistedDialogCz,
      ...loginPageCz,
      ...loginSecretWithPasswordPageCz,
      ...loginSecretWithPinPageCz,
      ...registerPersonalDataPageCz,
      ...registerPinPageCz,
      ...registerSecretDataPageCz,
      ...registerSuccessDataPageCz,

      // pages - components
      ...agbToAcceptCz,
      ...appFrameCz,
      ...buttonBarForContinueBookingCz,
      ...buttonBarForSelectedServiceCz,
      ...contactDataFormCz,
      ...contactUpdateDialogCz,
      ...cookiesDialogCz,
      ...footerCz,
      ...googleMapsEmbedIframeDialogCz,
      ...languageSelectionDialogCz,
      ...navigationBackButtonCz,
      ...newAppVersionNotificationCz,
      ...passwordFormCz,
      ...personalDataFormCz,
      ...processContainerCz,
      ...ratingStarIconCz,
      ...salonCardCz,
      ...cityCardCz,
      ...salonDetailsHeaderCz,
      ...staticContentBecomePartnerCz,
      ...staticContentDownloadAppCz,
      ...staticContentOnlineBookingBenefitCz,
      ...staticContentOnlineBookingProcessCz,

      // pages - feedback-process
      ...feedbackProcessPagesCz,
      ...feedbackEmotionPageCz,
      ...feedbackInternalDetailsPageCz,
      ...feedbackInternalSuccessPageCz,

      // pages - private
      ...appointmentDetailsPageCz,
      ...appointmentHistoryPageCz,
      ...accountPageContainerCz,
      ...appointmentCardCz,
      ...emailPhoneConfirmationPinDialogCz,
      ...updatePasswordPinDialogCz,
      ...qrCheckinConfigPageCz,
      ...qrCheckinSuccessPageCz,
      ...salonBookingConfigPageCz,
      ...salonVisitedPageCz,
      ...userProfilePageCz,

      // pages - public
      ...customerRegisterDialogCz,
      ...customerRegisterFormCz,
      ...customerRequestOnlineBookingDialogCz,
      ...salonDetailsFooterCz,
      ...salonSearchContainerCz,
      ...salonSearchFormCz,
      ...salonSearchFormAdvanceDialogCz,
      ...googleSalonDetailsPageCz,
      ...homePageCz,
      ...imprintPageCz,
      ...privacyPolicyPageCz,
      ...publicAppointmentDetailsPageCz,
      ...rwgCancelRequestPageCz,
      ...salonDetailsPageCz,
      ...salonSearchResultPageCz,
      ...topSalonsPageCz,
      ...topSalonsCityPageCz,
    };
  }

  getDeLanguageSet() {
    return {
      // common
      ...AgbFormLocalization.getDeLanguageSet(),
      ...CalendarLocalization.getDeLanguageSet(),
      ...updateProfileDe,

      // pages - auth-process
      ...authProcessPagesDe,
      ...accountExistedDialogDe,
      ...accountNotExistedDialogDe,
      ...loginPageDe,
      ...loginSecretWithPasswordPageDe,
      ...loginSecretWithPinPageDe,
      ...registerPersonalDataPageDe,
      ...registerPinPageDe,
      ...registerSecretDataPageDe,
      ...registerSuccessDataPageDe,

      // pages - components
      ...agbToAcceptDe,
      ...appFrameDe,
      ...buttonBarForContinueBookingDe,
      ...buttonBarForSelectedServiceDe,
      ...contactDataFormDe,
      ...contactUpdateDialogDe,
      ...cookiesDialogDe,
      ...footerDe,
      ...googleMapsEmbedIframeDialogDe,
      ...languageSelectionDialogDe,
      ...navigationBackButtonDe,
      ...newAppVersionNotificationDe,
      ...passwordFormDe,
      ...personalDataFormDe,
      ...processContainerDe,
      ...ratingStarIconDe,
      ...salonCardDe,
      ...cityCardDe,
      ...salonDetailsHeaderDe,
      ...staticContentBecomePartnerDe,
      ...staticContentDownloadAppDe,
      ...staticContentOnlineBookingBenefitDe,
      ...staticContentOnlineBookingProcessDe,

      // pages - feedback-process
      ...feedbackProcessPagesDe,
      ...feedbackEmotionPageDe,
      ...feedbackInternalDetailsPageDe,
      ...feedbackInternalSuccessPageDe,

      // pages - private
      ...appointmentDetailsPageDe,
      ...appointmentHistoryPageDe,
      ...accountPageContainerDe,
      ...appointmentCardDe,
      ...emailPhoneConfirmationPinDialogDe,
      ...updatePasswordPinDialogDe,
      ...qrCheckinConfigPageDe,
      ...qrCheckinSuccessPageDe,
      ...salonBookingConfigPageDe,
      ...salonVisitedPageDe,
      ...userProfilePageDe,

      // pages - public
      ...customerRegisterDialogDe,
      ...customerRegisterFormDe,
      ...customerRequestOnlineBookingDialogDe,
      ...salonDetailsFooterDe,
      ...salonSearchContainerDe,
      ...salonSearchFormDe,
      ...salonSearchFormAdvanceDialogDe,
      ...googleSalonDetailsPageDe,
      ...homePageDe,
      ...imprintPageDe,
      ...privacyPolicyPageDe,
      ...publicAppointmentDetailsPageDe,
      ...rwgCancelRequestPageDe,
      ...salonDetailsPageDe,
      ...salonSearchResultPageDe,
      ...topSalonsPageDe,
      ...topSalonsCityPageDe,
    };
  }

  getFrLanguageSet() {
    return {
      // common
      ...AgbFormLocalization.getFrLanguageSet(),
      ...CalendarLocalization.getFrLanguageSet(),
      ...updateProfileFr,

      // pages - auth-process
      ...authProcessPagesFr,
      ...accountExistedDialogFr,
      ...accountNotExistedDialogFr,
      ...loginPageFr,
      ...loginSecretWithPasswordPageFr,
      ...loginSecretWithPinPageFr,
      ...registerPersonalDataPageFr,
      ...registerPinPageFr,
      ...registerSecretDataPageFr,
      ...registerSuccessDataPageFr,

      // pages - components
      ...agbToAcceptFr,
      ...appFrameFr,
      ...buttonBarForContinueBookingFr,
      ...buttonBarForSelectedServiceFr,
      ...contactDataFormFr,
      ...contactUpdateDialogFr,
      ...cookiesDialogFr,
      ...footerFr,
      ...googleMapsEmbedIframeDialogFr,
      ...languageSelectionDialogFr,
      ...navigationBackButtonFr,
      ...newAppVersionNotificationFr,
      ...passwordFormFr,
      ...personalDataFormFr,
      ...processContainerFr,
      ...ratingStarIconFr,
      ...salonCardFr,
      ...cityCardFr,
      ...salonDetailsHeaderFr,
      ...staticContentBecomePartnerFr,
      ...staticContentDownloadAppFr,
      ...staticContentOnlineBookingBenefitFr,
      ...staticContentOnlineBookingProcessFr,

      // pages - feedback-process
      ...feedbackProcessPagesFr,
      ...feedbackEmotionPageFr,
      ...feedbackInternalDetailsPageFr,
      ...feedbackInternalSuccessPageFr,

      // pages - private
      ...appointmentDetailsPageFr,
      ...appointmentHistoryPageFr,
      ...accountPageContainerFr,
      ...appointmentCardFr,
      ...emailPhoneConfirmationPinDialogFr,
      ...updatePasswordPinDialogFr,
      ...qrCheckinConfigPageFr,
      ...qrCheckinSuccessPageFr,
      ...salonBookingConfigPageFr,
      ...salonVisitedPageFr,
      ...userProfilePageFr,

      // pages - public
      ...customerRegisterDialogFr,
      ...customerRegisterFormFr,
      ...customerRequestOnlineBookingDialogFr,
      ...salonDetailsFooterFr,
      ...salonSearchContainerFr,
      ...salonSearchFormFr,
      ...salonSearchFormAdvanceDialogFr,
      ...googleSalonDetailsPageFr,
      ...homePageFr,
      ...imprintPageFr,
      ...privacyPolicyPageFr,
      ...publicAppointmentDetailsPageFr,
      ...rwgCancelRequestPageFr,
      ...salonDetailsPageFr,
      ...salonSearchResultPageFr,
      ...topSalonsPageFr,
      ...topSalonsCityPageFr,
    };
  }

  getUsLanguageSet() {
    return {
      // common
      ...AgbFormLocalization.getUsLanguageSet(),
      ...CalendarLocalization.getUsLanguageSet(),
      ...updateProfileUs,

      // pages - auth-process
      ...authProcessPagesUs,
      ...accountExistedDialogUs,
      ...accountNotExistedDialogUs,
      ...loginPageUs,
      ...loginSecretWithPasswordPageUs,
      ...loginSecretWithPinPageUs,
      ...registerPersonalDataPageUs,
      ...registerPinPageUs,
      ...registerSecretDataPageUs,
      ...registerSuccessDataPageUs,

      // pages - components
      ...agbToAcceptUs,
      ...appFrameUs,
      ...buttonBarForContinueBookingUs,
      ...buttonBarForSelectedServiceUs,
      ...contactDataFormUs,
      ...contactUpdateDialogUs,
      ...cookiesDialogUs,
      ...footerUs,
      ...googleMapsEmbedIframeDialogUs,
      ...languageSelectionDialogUs,
      ...navigationBackButtonUs,
      ...newAppVersionNotificationUs,
      ...passwordFormUs,
      ...personalDataFormUs,
      ...processContainerUs,
      ...ratingStarIconUs,
      ...salonCardUs,
      ...cityCardUs,
      ...salonDetailsHeaderUs,
      ...staticContentBecomePartnerUs,
      ...staticContentDownloadAppUs,
      ...staticContentOnlineBookingBenefitUs,
      ...staticContentOnlineBookingProcessUs,

      // pages - feedback-process
      ...feedbackProcessPagesUs,
      ...feedbackEmotionPageUs,
      ...feedbackInternalDetailsPageUs,
      ...feedbackInternalSuccessPageUs,

      // pages - private
      ...appointmentDetailsPageUs,
      ...appointmentHistoryPageUs,
      ...accountPageContainerUs,
      ...appointmentCardUs,
      ...emailPhoneConfirmationPinDialogUs,
      ...updatePasswordPinDialogUs,
      ...qrCheckinConfigPageUs,
      ...qrCheckinSuccessPageUs,
      ...salonBookingConfigPageUs,
      ...salonVisitedPageUs,
      ...userProfilePageUs,

      // pages - public
      ...customerRegisterDialogUs,
      ...customerRegisterFormUs,
      ...customerRequestOnlineBookingDialogUs,
      ...salonDetailsFooterUs,
      ...salonSearchContainerUs,
      ...salonSearchFormUs,
      ...salonSearchFormAdvanceDialogUs,
      ...googleSalonDetailsPageUs,
      ...homePageUs,
      ...imprintPageUs,
      ...privacyPolicyPageUs,
      ...publicAppointmentDetailsPageUs,
      ...rwgCancelRequestPageUs,
      ...salonDetailsPageUs,
      ...salonSearchResultPageUs,
      ...topSalonsPageUs,
      ...topSalonsCityPageUs,
    };
  }

  getVnLanguageSet() {
    return {
      // common
      ...AgbFormLocalization.getVnLanguageSet(),
      ...CalendarLocalization.getVnLanguageSet(),
      ...updateProfileVn,

      // pages - auth-process
      ...authProcessPagesVn,
      ...accountExistedDialogVn,
      ...accountNotExistedDialogVn,
      ...loginPageVn,
      ...loginSecretWithPasswordPageVn,
      ...loginSecretWithPinPageVn,
      ...registerPersonalDataPageVn,
      ...registerPinPageVn,
      ...registerSecretDataPageVn,
      ...registerSuccessDataPageVn,

      // pages - components
      ...agbToAcceptVn,
      ...appFrameVn,
      ...buttonBarForContinueBookingVn,
      ...buttonBarForSelectedServiceVn,
      ...contactDataFormVn,
      ...contactUpdateDialogVn,
      ...cookiesDialogVn,
      ...footerVn,
      ...googleMapsEmbedIframeDialogVn,
      ...languageSelectionDialogVn,
      ...navigationBackButtonVn,
      ...newAppVersionNotificationVn,
      ...passwordFormVn,
      ...personalDataFormVn,
      ...processContainerVn,
      ...ratingStarIconVn,
      ...salonCardVn,
      ...cityCardVn,
      ...salonDetailsHeaderVn,
      ...staticContentBecomePartnerVn,
      ...staticContentDownloadAppVn,
      ...staticContentOnlineBookingBenefitVn,
      ...staticContentOnlineBookingProcessVn,

      // pages - feedback-process
      ...feedbackProcessPagesVn,
      ...feedbackEmotionPageVn,
      ...feedbackInternalDetailsPageVn,
      ...feedbackInternalSuccessPageVn,

      // pages - private
      ...appointmentDetailsPageVn,
      ...appointmentHistoryPageVn,
      ...accountPageContainerVn,
      ...appointmentCardVn,
      ...emailPhoneConfirmationPinDialogVn,
      ...updatePasswordPinDialogVn,
      ...qrCheckinConfigPageVn,
      ...qrCheckinSuccessPageVn,
      ...salonBookingConfigPageVn,
      ...salonVisitedPageVn,
      ...userProfilePageVn,

      // pages - public
      ...customerRegisterDialogVn,
      ...customerRegisterFormVn,
      ...customerRequestOnlineBookingDialogVn,
      ...salonDetailsFooterVn,
      ...salonSearchContainerVn,
      ...salonSearchFormVn,
      ...salonSearchFormAdvanceDialogVn,
      ...googleSalonDetailsPageVn,
      ...homePageVn,
      ...imprintPageVn,
      ...privacyPolicyPageVn,
      ...publicAppointmentDetailsPageVn,
      ...rwgCancelRequestPageVn,
      ...salonDetailsPageVn,
      ...salonSearchResultPageVn,
      ...topSalonsPageVn,
      ...topSalonsCityPageVn,
    };
  }
}

const languageLoaderHelper = new LanguageLoaderHelper();
export default languageLoaderHelper;
